import { addDays } from "@fullcalendar/core/internal";
import React, { useEffect, useState } from "react";
import ReactDatePicker from "react-datepicker";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import {
  LIST_COMMENTAIRE,
  LIST_RACCORDEMENT,
  UPDATE_RACCORDEMENT,
} from "../../Utils/constant";
import { updateOne } from "../../services/service";
import { useCommentaireStore } from "../../store/CommentaireStore";
import { useStoreApp } from "../../store/storeApp";
import { SubmitButton } from "../Widget/SubmitButton";

export const UpdateRaccordement = ({ numeroTicket, setActive }) => {
  const [dateStart, setStartDate] = useState(new Date());
  const [dateEnd, setEndDate] = useState(new Date());
  const [isSubmit, setIsSubmit] = useState(false);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const store = useStoreApp();
  const submit = (data) => {
    setIsSubmit(true);
    const requestData = {
      ...data,
      dateHDebut: dateStart.toISOString().slice(0, -1),

      dateHFin: dateEnd.toISOString().slice(0, -1),
      status: "REALISER",
      numeroTicket: numeroTicket,
    };
    updateOne(UPDATE_RACCORDEMENT, "", requestData)
      .then((res) => {
        if (res.status === 200) {
          store.getData(
            LIST_RACCORDEMENT,
            { page: 0, param: "", size: 10 },
            `&periode=&mois=&annee=&dateDebut=&dateFin=&status=REALISER&resultat=OK`
          );
          setActive({ index: 0, value: "" });
          document.getElementById("fermer").click();
          setIsSubmit(null);
          toast.success("Raccordement éffectuée");
        }
      })
      .catch((err) => {
        setIsSubmit(false);
        toast.error(err?.response?.data?.donnee);
      });
  };
  const commentaire = useCommentaireStore();

  useEffect(() => {
    commentaire.getData(LIST_COMMENTAIRE, { page: 0, param: "", size: 10 }, "");
  }, []);

  return (
    <form onSubmit={handleSubmit(submit)} className="lg:w-96">
      <div className="my-4 space-y-4">
        <div className="my-2">
          <label className="form-control  w-full">
            <div className="label -mb-1">
              <span className="label-text font-medium text-gray-400">
                Date et heure de debut <span className="text-red-500">*</span>
              </span>
            </div>

            <ReactDatePicker
              selected={dateStart}
              locale="pt-BR"
              timeIntervals={15}
              dateFormat="Pp"
              minDate={new Date()}
              showTimeSelect
              timeFormat="p"
              className=" px-2 flex items-center justify-center border-[1px] w-full h-8 rounded-lg"
              onChange={(date) => {
                setStartDate(date);
              }}
            />
          </label>

          <label className="form-control  w-full">
            <div className="label -mb-1">
              <span className="label-text font-medium text-gray-400">
                Date et heure de fin <span className="text-red-500">*</span>
              </span>
            </div>

            <ReactDatePicker
              selected={dateEnd}
              locale="pt-BR"
              timeIntervals={15}
              dateFormat="Pp"
              minDate={addDays(dateStart, 1)}
              showTimeSelect
              timeFormat="p"
              className=" px-2 flex items-center justify-center border-[1px] w-full h-8 rounded-lg"
              onChange={(date) => {
                setEndDate(date);
              }}
            />
          </label>
        </div>

        <div className="my-2">
          <label className="form-control w-full">
            <div className="label">
              <span className="label-text text-sm font-semibold">
                Resultat du raccordement <span className="text-red-500">*</span>
              </span>
            </div>
            <select
              {...register("resultat", { required: true })}
              className="select select-bordered w-full"
              onChange={(e) => {}}
            >
              <option value={""} disabled selected>
                Selectionnez un status
              </option>
              <option value={"OK"}>OK</option>
              <option value={"NON_OK"}>Non OK</option>
              <option value={"PARTIALY_OK"}>Partialy OK</option>
            </select>
          </label>
        </div>

        <label className="form-control w-full">
          <div className="label -mb-1">
            <span className="label-text font-medium text-gray-400">
              Type commentaire <span className="text-red-500">*</span>
            </span>
          </div>
          <select
            {...register("typeCommentaire", { required: true })}
            className="select select-bordered w-full h-10"
          >
            <option disabled selected>
              Selectionnez un type
            </option>
            {commentaire?.data?.data?.map((item) => (
              <option value={item.id}>{item.designation}</option>
            ))}
          </select>
        </label>

        <div className="my-2">
          <label htmlFor="" className="text-sm font-medium">
            Commentaire
          </label>
          <textarea
            {...register("commentaire")}
            placeholder="Votre commentaire"
            className="textarea textarea-bordered textarea-sm w-full"
          ></textarea>
        </div>
      </div>
      <SubmitButton isSubmit={isSubmit} label={"Valider"} />
    </form>
  );
};
